import { router } from '@inertiajs/react';
import { formatDistance } from 'date-fns';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { Trash2, ExternalLink } from 'lucide-react';

interface Chat {
  id: string;
  title: string;
  user_email: string;
  message_count: number;
  created_at: string;
}

interface IndexProps {
  chats: Chat[];
}

export default function Index({ chats }: IndexProps) {
  const handleDelete = (id: string) => {
    if (confirm('Are you sure you want to delete this chat?')) {
      router.delete(`/dev/chats/${id}`);
    }
  };

  const handleView = (id: string) => {
    window.open(`/chat/${id}`, '_blank');
  };

  return (
    <div className="container mx-auto p-8">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-semibold">All Chats</h1>
        <span className="text-sm text-muted-foreground">{chats.length} chats</span>
      </div>

      <div className="rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Title</TableHead>
              <TableHead>User</TableHead>
              <TableHead className="text-center">Messages</TableHead>
              <TableHead>Created</TableHead>
              <TableHead className="text-right">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {chats.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} className="text-center text-muted-foreground py-8">
                  No chats yet
                </TableCell>
              </TableRow>
            ) : (
              chats.map((chat) => (
                <TableRow key={chat.id}>
                  <TableCell className="font-medium">{chat.title}</TableCell>
                  <TableCell className="text-muted-foreground">{chat.user_email}</TableCell>
                  <TableCell className="text-center">{chat.message_count}</TableCell>
                  <TableCell className="text-muted-foreground">
                    {formatDistance(new Date(chat.created_at), new Date(), { addSuffix: true })}
                  </TableCell>
                  <TableCell className="text-right">
                    <div className="flex items-center justify-end gap-2">
                      <Button variant="ghost" size="icon" onClick={() => handleView(chat.id)}>
                        <ExternalLink className="h-4 w-4" />
                      </Button>
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => handleDelete(chat.id)}
                        className="text-destructive hover:text-destructive"
                      >
                        <Trash2 className="h-4 w-4" />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
